// export const baseurl="https://api.escuelajs.co/api/v1/categories";
export const baseurl="https://api.pujakaitem.com/api/"